import React from 'react';
import { useTranslation } from 'react-i18next';

const PackagingPropertiesForm = ({ editData, onFieldChange, disabled = false }) => {
  const { t } = useTranslation('warehouse');
  const handleFieldChange = (field, value) => {
    onFieldChange(field, value);
  };

  return (
    <div className="form-section">
      <h3>{t('packagingPropertiesForm.title')}</h3>
      <div className="form-grid">
        <div className="form-group">
          <label>{t('packagingPropertiesForm.packageType')}</label>
          <select
            value={editData.package_type || ''}
            onChange={(e) => handleFieldChange('package_type', e.target.value)}
            disabled={disabled}
          >
            <option value="" disabled hidden>{t('packagingPropertiesForm.selectPackageType')}</option>
            <option value="BOX">{t('packagingPropertiesForm.types.BOX')}</option>
            <option value="ROLL">{t('packagingPropertiesForm.types.ROLL')}</option>
            <option value="SHEET">{t('packagingPropertiesForm.types.SHEET')}</option>
            <option value="TUBE">{t('packagingPropertiesForm.types.TUBE')}</option>
            <option value="BAG">{t('packagingPropertiesForm.types.BAG')}</option>
          </select>
        </div>

        <div className="form-group">
          <label>{t('packagingPropertiesForm.dimensions')}</label>
          <input
            type="text"
            value={editData.dimensions || ''}
            onChange={(e) => handleFieldChange('dimensions', e.target.value)}
            disabled={disabled}
            placeholder={t('packagingPropertiesForm.dimensionsPlaceholder')}
            maxLength="100"
          />
        </div>

        <div className="form-group">
          <label>{t('packagingPropertiesForm.capacity')}</label>
          <input
            type="number"
            step="0.001"
            value={editData.capacity || ''}
            onChange={(e) => handleFieldChange('capacity', parseFloat(e.target.value) || null)}
            disabled={disabled}
            placeholder={t('packagingPropertiesForm.capacity')}
          />
        </div>

        <div className="form-group">
          <label>{t('packagingPropertiesForm.weight')}</label>
          <input
            type="number"
            step="0.001"
            value={editData.weight || ''}
            onChange={(e) => handleFieldChange('weight', parseFloat(e.target.value) || null)}
            disabled={disabled}
            placeholder={t('packagingPropertiesForm.weight')}
          />
        </div>

        <div className="form-group">
          <label>{t('packagingPropertiesForm.closureType')}</label>
          <input
            type="text"
            value={editData.closure_type || ''}
            onChange={(e) => handleFieldChange('closure_type', e.target.value)}
            disabled={disabled}
            placeholder={t('packagingPropertiesForm.closureTypePlaceholder')}
            maxLength="50"
          />
        </div>

        <div className="form-group full-width">
          <label>{t('packagingPropertiesForm.barrierProperties')}</label>
          <textarea
            value={editData.barrier_properties || ''}
            onChange={(e) => handleFieldChange('barrier_properties', e.target.value)}
            disabled={disabled}
            placeholder={t('packagingPropertiesForm.barrierPropertiesPlaceholder')}
            rows="3"
          />
        </div>
      </div>
    </div>
  );
};

export default PackagingPropertiesForm;